import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import CalculatorsLargeStyles from './CalculatorsLarge.styled';
import Link from '../Shared/Link';

const defaultCalculators = [
  {
    title: 'Mortgage calculator',
    to: '/calculators/mortgage-calculator/',
    description: 'Estimate your monthly mortgage payment',
  },
  {
    title: 'Early payoff calculator',
    to: '/calculators/early-payoff-calculator',
    description: 'Calculate how to reach your goals faster',
  },
  {
    title: 'Amortization calculator',
    to: '/calculators/amortization-calculator/',
    description:
      'Estimate how much money goes towards your principal and interests',
  },
  {
    title: 'Extra monthly principal',
    to: '/calculators/extra-monthly-principal/',
    description: 'Explore adding more to your monthly payment',
  },
  {
    title: 'Biweekly extra calculator',
    to: '/calculators/biweekly-extra-principal/',
    description: 'Get the most out of biweekly payments',
  },
];

const CalculatorsLarge = ({
  calculators = defaultCalculators,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });
  return (
    <CalculatorsLargeStyles
      ref={ref}
      className={`block-calculators_large ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        <header>
          <h2>Calculators</h2>
        </header>
        <section className='calculators'>
          {calculators.length !== 0 && (
            <ul>
              {calculators.map(
                ({ title = '', to = '', description = '' }, i) => (
                  <li
                    key={title}
                    style={{ animationDelay: `${i * 0.2 + 0.2}s` }}
                  >
                    <Link to={to}>{title}</Link>
                    <p>{description}</p>
                  </li>
                )
              )}
            </ul>
          )}
        </section>
      </div>
    </CalculatorsLargeStyles>
  );
};

CalculatorsLarge.propTypes = {};

export default CalculatorsLarge;
